import { log } from './console.js';
import { isPlainObject } from './utils';

/**
 * Check if properties specified in `required` object are set in `object`
 * @param {object} object Object to validate
 * @param {object} required Property required flag map
 * @param {string[]} [propertyPath=[]]
 */
export function validateDataObject(object, required, propertyPath = []) {
  const keys = Object.keys(required);

  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const value = object[key];

    if (isPlainObject(value)) {
      propertyPath.push(key);

      return validateDataObject(value, required[key], propertyPath);
    }

    if (value === undefined) {
      log.error(`${propertyPath.length ? `${propertyPath.join('.')}.` : ''}${key} is required!`);

      return false;
    }
  }

  return true;
}
